export default __webpack_public_path__ + "static/media/systemowe9.9fc132ad.jpg";